import * as React from 'react';
import { SVGProps } from 'react';

const IconAddSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 2H7v5H2v2h5v5h2V9h5V7H9V2z" />
  </svg>
);

export default IconAddSizeS;
